<template>
  <div class="content">
    <!-- 面包屑 -->
    <!-- <div class="breadcrumb">
      <i class="iconfont icondqwz"></i>
      <ul>
        <li class="active">系统管理</li>
      </ul>
    </div>-->
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 角色管理
        </span>
        <div class="w_normalNav" :parent="self">
          <button class="GreenSmBtn" @click="addNew">添加</button>
          <!-- <button class="OrangeSmBtn">重置</button>
          <button class="BlueSmBtn">搜索</button>-->
        </div>

        <div class="tableWrapper" v-loading="!showTable">
          <!-- 后端分页 -->
          <easyTable
            apiUrl="operation/roleList"
            :parent="self"
            :config="config"
            :other="other"
            ref="role"
          >
            <template slot="last">
              <el-table-column label="操作" width="300" align="center">
                <template slot-scope="scope">
                  <el-link
                    icon="iconfont iconedit"
                    type="text"
                    size="small"
                    @click="edit(scope.$index, scope.row)"
                  >编辑</el-link>
                  <el-link
                    icon="iconfont iconedit"
                    type="text"
                    size="small"
                    @click="appEdit(scope.$index, scope.row)"
                  >APP菜单权限</el-link>
                  <!-- <el-link icon="iconfont iconadd" type="text" size="small">添加</el-link> -->
                  <el-link
                    icon="iconfont icondelete"
                    type="text"
                    size="small"
                    @click="deleteMsg(scope.$index, scope.row)"
                  >删除</el-link>
                </template>
              </el-table-column>
            </template>
          </easyTable>
        </div>
        <!-- <el-dialog class="editDialog" title="修改用户信息" :visible.sync="editDialogVisible">
          <searchForm :items="items"></searchForm>
          <div slot="footer" class="dialog-footer">
            <el-button class="cancelButton" @click="editDialogVisible = false">取消</el-button>
            <el-button class="confirmButton" type="primary" @click="editDialogVisible = false">确定</el-button>
          </div>
        </el-dialog>-->
        <el-dialog
          class="editDialog"
          :visible.sync="dialogForm"
          :title="title"
          :close-on-click-modal="false"
        >
          <el-form :model="formMsg" ref="formMsg" :rules="rules">
            <el-form-item label="角色名" prop="name">
              <el-input placeholder="请输入角色名" v-model.trim="formMsg.name"></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
              <el-input placeholder="请输入备注" v-model.trim="formMsg.remark"></el-input>
            </el-form-item>
            <el-form-item label="权限选择" prop="permission">
              <el-tree
                class="role_tree"
                :data="data2"
                :props="props"
                show-checkbox
                default-expand-all
                :default-checked-keys="checkPermissionIds"
                node-key="id"
                :check-strictly="checkStrictly"
                ref="tree"
              ></el-tree>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer" v-if="showBtn">
            <el-button class="cancelButton" @click="dialogForm = false">取消</el-button>
            <el-button class="confirmButton" type="primary" @click="submitAdd">确定</el-button>
          </div>
        </el-dialog>
        <el-dialog
          class="editDialog"
          :visible.sync="appDialogForm"
          title="app菜单权限"
          :close-on-click-modal="false"
        >
          <el-form :model="appFormMsg" ref="appFormMsg" :rules="rules">
            <el-form-item label="角色名" prop="name">
              <el-input placeholder="请输入角色名" v-model.trim="appFormMsg.name" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
              <el-input placeholder="请输入备注" v-model.trim="appFormMsg.remark" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="app菜单权限选择" prop="permission">
              <el-tree
                class="role_tree"
                :data="data2"
                :props="appProps"
                show-checkbox
                default-expand-all
                :default-checked-keys="checkPermissionIds"
                node-key="id"
                :check-strictly="checkStrictly"
                ref="tree2"
              ></el-tree>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer" v-if="showBtn">
            <el-button class="cancelButton" @click="dialogForm = false;appDialogForm = false">取消</el-button>
            <el-button class="confirmButton" type="primary" @click="submitAdd_app">确定</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { dt, obj2urlsp } from "utils";

export default {
  data() {
    return {
      loading: true,
      title: "",
      tabName: "jsgl",
      loading: true,
      form_jsgl: {},
      editDialogVisible: false,
      showTable: true,
      showBtn: true,
      other: {},
      dialogForm: false,
      appDialogForm: false,
      data2: [],
      props: {
        children: "children",
        label: "label"
      },
      appProps: {
        children: "children",
        label: "name"
      },
      formMsg: {
        name: "",
        remark: ""
      },
      appFormMsg: {
        name: "",
        remark: ""
      },
      //角色关联的权限ID
      checkPermissionIds: [],
      //校验
      rules: {
        name: [{ required: true, message: "请输入角色名称",  trigger: 'blur' }],
        remark: [{ required: true, message: "请输入备注", trigger: 'blur' }],
        // permission: [{ required: true,}]
      },
      checkStrictly:true
    };
  },
  computed: {
    self() {
      return this;
    },
    config() {
      return [
        {
          prop: "name",
          label: "角色名"
        },
        {
          prop: "remark",
          label: "备注"
        }
        // {
        //   prop: (row, column) => row.oildrum.rfid_number + row.oildrum.imei,
        //   label: "随便"
        // }
      ];
    },
    dt() {
      return dt.map(({ label }) => label);
    }
  },
  components: {
    normalNav: () => import("public/normalNav"),
    searchForm: () => import("public/searchForm"),
    easyTable: () => import("public/easyTable")
  },
  methods: {
    //搜索
    subSeefrom() {
      //   this.other = this.seefrom;
      this.$nextTick(this.$refs.role.getData);
    },
    //新增
    addNew() {
      this.title = "新增角色";
      this.statuCode = 1;
      this.checkStrictly = false;
      this.dialogForm = true;
      this.formMsg = {
        name: "",
        perms: "",
        remark: ""
      };
      this.getTree();
      this.$refs.tree.setCheckedKeys([]);
      this.$nextTick(() => {
        this.$refs["formMsg"].clearValidate();
      });
    },
    //修改
    edit(index, row) {
      //console.log(index, row)
      this.title = "修改角色信息";
      this.userID = row.id;
      this.data2=[]
      this.dialogForm = true;
      this.checkStrictly = true;
      this.statuCode = 2;
      this.formMsg.name = row.name;
      this.formMsg.perms = row.perms;
      this.formMsg.remark = row.remark;
      this.$axiosget("operation/roleTreeList", {
        params: {
          id: row.id
        }
      }).then(res => {
        if (res.data.status === "10000") {
          this.data2 = res.data.data.treeNodeList;
          let permissionIds = res.data.data.permissionIds;
          // this.checkPermissionIds = [];//需要选中的节点
          // this.checkPermissionIds = this.$refs.tree.getCheckedNodes(true);
          // //console.log(res.data.data.treeNodeList,this.checkPermissionIds,"permissions")
          // const removeValue = (arr, value) => {
          //   for (let i = 0; i < arr.length; i++) {
          //     if (arr[i] === value) {
          //       arr.splice(i, 1);
          //     }
          //   }
          //   return;
          // };
          // removeValue(permissionIds, 158);
          // removeValue(permissionIds, 223);
          this.$refs.tree.setCheckedKeys(permissionIds);
          this.$nextTick(()=>{this.checkStrictly=false;this.$refs["formMsg"].clearValidate();});
        }
      });
          
    },
     //修改
     appEdit(index, row) {
      //console.log(index, row)
      this.title = "修改角色信息";
      this.userID = row.id;
      this.data2=[]
      this.appDialogForm = true;
      this.checkStrictly = true;
      this.statuCode = 2;
      this.appFormMsg.name = row.name;
      this.appFormMsg.perms = row.perms;
      this.appFormMsg.remark = row.remark;
      this.$axiosget("operation/appPermission", {
        params: {
          id: row.id
        }
      }).then(res => {
        if (res.data.status === "10000") {
          this.data2 = res.data.data.appPermissions;
          let permissionIds = res.data.data.permissionIds;
          // this.checkPermissionIds = [];//需要选中的节点
          // this.checkPermissionIds = this.$refs.tree.getCheckedNodes(true);
          // //console.log(res.data.data.treeNodeList,this.checkPermissionIds,"permissions")
          // const removeValue = (arr, value) => {
          //   for (let i = 0; i < arr.length; i++) {
          //     if (arr[i] === value) {
          //       arr.splice(i, 1);
          //     }
          //   }
          //   return;
          // };
          // removeValue(permissionIds, 158);
          // removeValue(permissionIds, 223);
          this.$refs.tree2.setCheckedKeys(permissionIds);
          this.$nextTick(()=>this.checkStrictly=false);
        }
      });
    },
    //删除
    deleteMsg(index, row) {
      this.$confirm("确定删除角色?", "删除操作", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let params = new URLSearchParams();
        params.append("id", row.id);
        this.$axiospost("operation/deleterole", params)
          .then(res => {
            if (res.data.status === "10000") {
              this.$message.success("删除成功");
              this.subSeefrom();
            } else {
              this.$message.error(res.data.message);
            }
          })
          .catch(error => {
            setTimeout(() => {
              let loading = Loading.service({});
              loading.close();
              this.$message.error("删除失败");
            }, 2000);
          });
      }).catch(()=>{

      })
    },
    //确认
    submitAdd() {
      //console.log(this.$refs["formMsg"]);
      this.$refs["formMsg"].validate(valid => {
        if (valid) {
          if (this.statuCode === 1) {
            let params = new URLSearchParams();
            params.append("name", this.formMsg.name);
            params.append("perms", this.formMsg.perms);
            params.append("remark", this.formMsg.remark);
            params.append(
              "permissionIds",
              this.$refs.tree
                .getHalfCheckedKeys()
                .concat(this.$refs.tree.getCheckedKeys())
            );
            let permissionIds1 = this.$refs.tree
              .getHalfCheckedKeys()
              .concat(this.$refs.tree.getCheckedKeys());
            //console.log(permissionIds1, "permissionIds1");
            if (permissionIds1.length === 0) {
              this.$message.warning("请选择角色权限！")
            } else {
              this.$axiospost("operation/addrole", params).then(res => {
                if (res.data.status === "10000") {
                  this.dialogForm = false;
                  this.subSeefrom();
                  this.$message.success("添加成功！");
                }
              });
            }
          } else if (this.statuCode === 2) {
            let params = new URLSearchParams();
            params.append("id", this.userID);
            params.append("name", this.formMsg.name);
            params.append("perms", this.formMsg.perms);
            params.append("remark", this.formMsg.remark);
            params.append(
              "permissionIds",
              this.$refs.tree
                .getHalfCheckedKeys()
                .concat(this.$refs.tree.getCheckedKeys())
            );
            let permissionIds2 = this.$refs.tree
              .getHalfCheckedKeys()
              .concat(this.$refs.tree.getCheckedKeys());
            //console.log(permissionIds2, "permissionIds2");
            if (permissionIds2.length === 0) {
              this.$message.warning("请选择角色权限！")
            } else {
              this.$axiospost("operation/updaterole", params).then(res => {
                if (res.data.status === "10000") {
                  this.$message.success("修改成功");
                  this.dialogForm = false;
                  this.subSeefrom();
                }
              });
            }
          }
        } else {
          this.$message.error("保存失败，请输入必填项！");
        }
      });
    },

    //确认
    submitAdd_app() {
      //console.log(this.$refs["formMsg"]);
      this.$refs["appFormMsg"].validate(valid => {
        if (valid) {
            let permissionIds2 = this.$refs.tree2
              .getHalfCheckedKeys()
              .concat(this.$refs.tree2.getCheckedKeys());
            //console.log(permissionIds2, "permissionIds2");
            if (permissionIds2.length === 0) {
              this.$message.warning("请选择角色权限！")
            }
            else if (permissionIds2.length < 3||permissionIds2.length > 5) {
              this.$message.warning("app菜单个数需多于2个、少于6个")
            }
             else {
              console.log(this.$refs.tree2.getHalfCheckedKeys().concat(this.$refs.tree2.getCheckedKeys()).join());
              this.$axiospost("operation/appPermission", {
                id:this.userID,
                perms:this.$refs.tree2
                .getHalfCheckedKeys()
                .concat(this.$refs.tree2.getCheckedKeys()).join()
              }).then(res => {
                if (res.data.status === "10000") {
                  this.$message.success("修改成功");
                  this.appDialogForm = false;
                  this.subSeefrom();
                }
              });
            }
        } else {
          this.$message.error("保存失败，请输入必填项！");
        }
      });
    },
    getTree() {
      this.data2=[]
      this.$axios
        .get(process.env.API_HOST + "operation/roleTreeList")
        .then(res => {
          //console.log(res);
          if (res.data.status === "10000") {
            this.data2 = res.data.data.treeNodeList;
          }
        });
    }
  },
  mounted() {}
};
</script>

<style lang="less" scoped>
.w_normalNav {
  padding-top: 10px;
  height: 52px;
  position: absolute;
  top: -52px;
  right: 32px;
  z-index: 99;
}
.el-input__inner:focus {
  border: 1px solid #3587c7;
}
.editDialog {
  .role_tree {
    width: 310px;
    border: 1px solid #3d4963;
    background: transparent;
    color: #cacaca;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute2/systemConfiguration/first/system/role/index.vue